import { Icon } from "../../components/Icon";
import { useCatalogScope } from "./CatalogProvider";
import { useT } from "../../i18n/strings";
import s from "./catalog.module.css";

interface CatalogSwitcherProps {
  onOpenSettings?: () => void;
}

/** Catalog picker (when shared) and entry to public/theme/invite settings. */
export function CatalogSwitcher({ onOpenSettings }: CatalogSwitcherProps) {
  const t = useT();
  const { catalogs, active, setCatalogOwner } = useCatalogScope();
  const showSwitcher = catalogs.length > 1;
  const showSettings = Boolean(onOpenSettings && active?.is_own);

  if (!showSwitcher && !showSettings) return null;

  return (
    <div className={s.row}>
      {showSwitcher && (
        <label className={s.switcher}>
          <Icon name="catalog" size={16} />
          <select
            className={s.switcherLabel}
            value={active?.owner_telegram_id ?? ""}
            aria-label={t.catalog.switchLabel}
            onChange={(event) => setCatalogOwner(Number(event.target.value))}
          >
            {catalogs.map((row) => (
              <option key={row.owner_telegram_id} value={row.owner_telegram_id}>
                {row.is_own ? t.catalog.ownCatalog : row.display_name || t.catalog.sharedCatalog}
              </option>
            ))}
          </select>
        </label>
      )}
      {showSettings && (
        <button type="button" className={s.switcher} onClick={onOpenSettings}>
          <Icon name="share" size={16} />
          {t.catalog.settingsTitle}
        </button>
      )}
    </div>
  );
}
